module.exports = __webpack_public_path__ + "img/Inspiration.1aec1411.svg";